import {
  BRAND_VISIBILITY_GET_URL,
  BRAND_VISIBILITY_POST_URL
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getBrandVisibility = associationsNum => (dispatch, getState) =>
  asyncRequest({
    url: BRAND_VISIBILITY_GET_URL(associationsNum),
    successAction: data => ({
      type: types.GET_BRAND_VISIBILITY_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.GET_BRAND_VISIBILITY_FAILURE,
      payload: error
    }),
    dispatch
  });

export const postBrandVisibility = payloadBody => (dispatch, getState) =>
  asyncRequest({
    url: BRAND_VISIBILITY_POST_URL(),
    method: 'POST',
    data: payloadBody,
    successAction: data => ({
      type: types.POST_BRAND_VISIBILITY_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.POST_BRAND_VISIBILITY_FAILURE,
      payload: error
    }),
    dispatch
  });
export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
